var properties = {
    "pl": {
        "languageLabel": "Language",
        "en": "English",
        "zh": "中文",
        "es": "Spanish",
        "pt": "Portuguese",
        "de": "Deutsch",
        "koLabel": "kolszewskieu",
        "koUrl": "http://kolszewski.eu",
        "title": "Email Signature Generator",
        "subtitle": "Give us your details and we'll give you your brand.",
        "nameLabel": "Name",
        "titleLabel": "Title",
        "emailLabel": "Email",
        "telephoneLabel": "Telephone",
        "themeLabel": "Theme",
        "black": "Black",
        "blue": "Blue",
        "earth": "Earth",
        "green": "Green",
        "iceBlue": "Ice Blue",
        "lime": "Lime",
        "magenta": "Magenta",
        "mint": "Mint",
        "ocean": "Ocean",
        "orange": "Orange",
        "pink": "Pink",
        "plum": "Plum",
        "red": "Red",
        "warmth": "Warmth",
        "previewLabel": "Preview",
        "selectSignatureLabel": "Select Signature",
        "instructionsLead": "After selecting your signature,",
        "instructions": "you will need to manually copy and paste it into your email client.",
        "footnote": "Created by KO"
    }
}

export default {properties};


// WEBPACK FOOTER //
// ./src/properties.js